var VueScrollTo = require('vue-scrollto');

import {BootstrapVue} from 'bootstrap-vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueSweetalert2 from 'vue-sweetalert2';
import SweetModal from 'sweet-modal-vue/src/plugin.js';

function plugin(Vue) {
	//Componentes llamados
	Vue.component('spinner', require( './page/daniel/shared/spinner.vue').default);
	Vue.component('ui-spinner', require( './page/daniel/shared/spinner.vue').default);
	Vue.component('static-image', require( './page/daniel/staticImage.vue').default);
	Vue.component('static-markdown', require( './page/daniel/shared/staticMarkdown.vue').default);
	Vue.component('my-header', require( './page/shared/header.vue').default);
	Vue.component('my-footer', require( './page/shared/footer.vue').default);
	Vue.component('ui-input', require( './page/shared/UiInput.vue').default);
	Vue.component('ui-select', require( './page/daniel/ui-select.vue').default);
	Vue.component('lock-button', require( './page/shared/lock-button.vue').default);
	Vue.component('products-search-bar', require( './page/products/products-search-bar.vue').default);
	// Vue.component('slick',slick);
	Vue.use(BootstrapVue);
	Vue.use(VueAwesomeSwiper, /* { default global options } */);
	Vue.use(VueSweetalert2);
	Vue.use(SweetModal);
	Vue.use(VueScrollTo, {
		container: "body",
		duration: 500,
		easing: "ease",
		offset: 0,
		force: true,
		cancelable: true,
		onStart: false,
		onDone: false,
		onCancel: false,
		x: false,
		y: true
	});
}

// Install by default if using the script tag
if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(plugin)
}

export default plugin
